<template>
  <div class="createNewOrder">
    <div class="header_top">
      <div style="font-size: 18px">
        {{ $t("other.a2835") }}
      </div>
      <div style="margin-right: 245px">
        <el-button size="medium" type="danger" @click="createOrder(form)">{{
          $t("other.a2836")
        }}</el-button>
        <el-button size="medium" type="primary" @click="back()">{{
          $t("other.a605")
        }}</el-button>
      </div>
    </div>
    <!-- <div class="title">自建手工单</div> -->
    <div class="receiptInfo">
      <div class="desc_title">{{ $t("other.a613") }}</div>
      <el-form
        class="vjhkbnv"
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
      >
        <div style="display: flex; margin-bottom: 20px">
          <el-form-item :label="$t('other.a518') + ':'" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('other.a519') + ':'" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item :label="$t('other.a626') + ':'">
            <el-input v-model="form.zipCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('other.a481') + ':'" prop="country">
            <el-select v-model="form.country" :placeholder="$t('other.a627')">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="display: flex">
          <el-form-item :label="$t('other.a628') + ':'" prop="city">
            <el-input v-model="form.city"></el-input>
          </el-form-item>
          <el-form-item :label="$t('other.a629') + ':'" prop="state">
            <el-input v-model="form.state"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('other.a630') + ':'"
            style="width: 100%"
            prop="fullAddress"
          >
            <el-input v-model="form.fullAddress"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="receiptInfo">
      <div class="desc_title">
        <span>{{ $t("other.a379") }}</span>
      </div>
      <div style="margin-top: 20px">
        <el-table
          style="width: 50%"
          border
          ref="multipleTable"
          :data="ruleForm.storeItems"
          tooltip-effect="dark"
          :row-key="(row) => row.cusCode"
          @selection-change="handleSelectionChangeMore"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            :selectable="selectable"
            width="55"
          >
          </el-table-column>
          <el-table-column :label="$t('other.a217')" width="80">
            <template slot-scope="scope">
              <div style="width: 60px; height: 60px; overflow: hidden">
                <img style="width: 100%" :src="scope.row.image" />
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a1251')">
            <template slot-scope="scope">
              <span>{{ scope.row.modelData.variationSku }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('other.a310')">
            <template slot-scope="scope">
              {{ scope.row.storeNum }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
  
  <script>
import api from "@/api/api";
import utils from "../../../utils/utils";
export default {
  data() {
    return {
      form: {
        city: null,
        country: null,
        district: null,
        name: null,
        orderId: null,
        phone: null,
        state: null,
        town: null,
        zipCode: null,
        fullAddress: null,
        country: null,
        emptyOrder: false,
        flagColor: null,
        flagDes: null,
        flagId: null,
        hidden: true,
        items: [],
        logistics: "",
        messageToSeller: null,
        msgToStore: null,
        note: null,
        trackingNo: null,
        storeId: null,
        storeName: null,
        sellerId:null,
        userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      },
      ruleForm: {},
      warehouseItemList: [],
      selectList: [],
      rules: {
        name: [
          { required: true, message: this.$t("other.a638"), trigger: "blur" },
        ],
        city: [
          { required: true, message: this.$t("other.a639"), trigger: "blur" },
        ],
        phone: [
          { required: true, message: this.$t("other.a640"), trigger: "blur" },
        ],
        state: [
          { required: true, message: this.$t("other.a641"), trigger: "blur" },
        ],
        town: [
          { required: true, message: this.$t("other.a642"), trigger: "blur" },
        ],
        fullAddress: [
          { required: true, message: this.$t("other.a643"), trigger: "blur" },
        ],
        country: [
          { required: true, message: this.$t("other.a644"), trigger: "blur" },
        ],
      },
      options: [
        {
          label: this.$t("chat.Thailand"),
          value: "TH",
        },
        {
          label: this.$t("h5.DSX_index_my"),
          value: "MY",
        },
        {
          label: this.$t("h5.DSX_index_ph"),
          value: "PH",
        },
        {
          label: this.$t("h5.DSX_index_vn"),
          value: "VN",
        },
        {
          label: this.$t("chat.Singapore"),
          value: "SG",
        },
        {
          label: this.$t("chat.Indonesia"),
          value: "ID",
        },
      ],
    };
  },
  computed: {},
  components: {},

  watch: {},

  mounted() {
    this.options = utils.getCountryOption();
    this.getGroupInfo();
    console.log(this.options);
  },
  methods: {
    selectable: function (row, index) {
      // 地址不是 "秦皇岛市海港区居民" 才能被选中
      if (row.storeNum != 0) {
        return true;
      }

      // 函数必须有返回值且是布尔值
      // 页面刷新后该函数会执行 N 次进行判断(N 为表格行数)
      // 如果没有返回值则默认返回false(全部无法选中)
    },
    getGroupInfo() {
      api
        .getStoreItemByGroupId({
          groupId: this.$route.query.groupId,
        })
        .then((res) => {
          if (res.code == 200) {
            let list = res.data;
            this.form.sellerId = res.data.userId
            api
              .getProductByproductId({ productId: list.productId })
              .then((res) => {
                if (res.code === 200) {
                  let communityList = res.data;
                  list.storeItems.forEach((p) => {
                    let mainItem = communityList.variations.find(
                      (item) => item.cusCode == p.cusCode
                    );
                    p.modelData = mainItem;
                  });
                  this.ruleForm = list;
                  console.log("ruleForm", this.ruleForm);
                } else {
                  this.message.warning(res.msg);
                }
              });
          }
        });
    },
    handleSelectionChangeMore(val) {
      console.log(val);
      this.selectList = [];
      this.multipleSelection = val;
      this.selectList = val;

      console.log("multipleSelection", this.multipleSelection);
    },
    back() {
      this.$router.back();
    },
    createOrder(form) {
      this.form.shipByDate = utils.getRecentDays(3);

      if (!this.multipleSelection || (this.multipleSelection && this.multipleSelection == 0)) {
        this.$message.warning(this.$t("other.a3083"));
        return;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.groupId = this.multipleSelection[0].groupId
          let data = {
            freeApplyItems: this.multipleSelection,
            freeApplyOrder: this.form,
          };

          api.freeApplyOrderApply(data).then((res) => {
            console.log(res)
            if (res.code === 200) {
              this.$confirm(this.$t("other.a2837"), this.$t("other.a142"), {
                confirmButtonText: this.$t("other.a955"),
                showClose: false,
                showCancelButton: false,
                closeOnClickModal:false,
                type: "warning",
              }).then(() => {
                this.back();
              });
            } else {
              this.$message.warning(res.msg);
            }
          });
        } else {
          this.$message.warning(this.$t("other.a649"));
          return false;
        }
      });
    },
  },
};
</script>
  <style lang="scss" scoped>
$linkColor: #363a3d;
.createNewOrder {
  background-color: #eee;
  height: 100vh;
  position: relative;
  padding-top: 60px;

  .vbknv {
    margin-right: 20px;
  }

  .header_top {
    width: 100%;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 50px;
    z-index: 99;
    padding: 8px 15px;

    box-shadow: 0 2px 6px 0 rgba($linkColor, 0.3);
  }

  .title {
    font-size: 18px;
    font-weight: bold;
  }
  .receiptInfo {
    background-color: #fff;
    box-sizing: border-box;

    padding: 20px 5px;
    margin: 5px;

    .desc_title {
      font-size: 18px;
      font-weight: 500;
      display: flex;
      justify-content: space-between;
    }

    .vjhkbnv {
      /deep/ .edit-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #9797a1;
        font-size: 14px;
        height: 40px;
        margin-top: 20px;
        border-bottom: 1px solid #e3e3e3;
      }

      /deep/ .el-form-item {
        margin-bottom: 0px;
      }

      /deep/ .el-form-item__content {
        border-bottom: 1px solid #000;
      }

      /deep/ .el-input__inner {
        width: 100%;
        border: none !important;
      }
      /deep/ .el-input--mini {
        width: 170px !important;
      }
    }
  }
}
</style>